// extracted by mini-css-extract-plugin
module.exports = {"TableHead":"TableHead__3sU6G"};